import { all, call, put, SagaReturnType, select, takeLatest } from 'redux-saga/effects';

import * as errorHandlerActions from '@/components/errorHandler/Actions';
import * as notificationsActions from '@/components/notifications/Actions';
import { notificationsActionTypes } from '@/components/notifications/Constants';
import { getNotificationStatusPath, ROUTES_API } from '@/services/Constants';
import { processRequest } from '@/services/Api';

import { page, perPage } from '@/components/notifications/Selectors';

import type { UpdateNotificationStatusRequestAction } from '@/components/notifications/Actions';
import type { NotificationsData } from '@/components/notifications/types';

export default function* () {
	yield all([
		takeLatest(
			notificationsActionTypes.GET_NOTIFICATIONS_REQUEST,
			handleGetNotificationsRequest,
		),
		takeLatest(
			notificationsActionTypes.UPDATE_NOTIFICATION_STATUS_REQUEST,
			handleNotificationStatusRequest,
		),
	]);
}

export function* handleGetNotificationsRequest() {
	try {
		const currentPage: number = yield select(page);
		const perPageItems: number = yield select(perPage);

		const requestPayload = {
			page: currentPage,
			per_page: perPageItems,
		};
		const response: SagaReturnType<typeof processRequest> = yield call(
			processRequest,
			ROUTES_API.NOTIFICATIONS,
			'GET',
			requestPayload,
		);

		const data = response.data as NotificationsData;
		yield put(notificationsActions.getNotificationsSuccess(data));
	} catch (e) {
		yield put(errorHandlerActions.handleError(e, 'notification'));
		yield put(notificationsActions.getNotificationsError());
	}
}

export function* handleNotificationStatusRequest(action: UpdateNotificationStatusRequestAction) {
	try {
		const { notificationId } = action.payload;
		const requestPayload = {
			notification: {
				read: true,
			},
		};

		yield call(
			processRequest,
			getNotificationStatusPath(String(notificationId)),
			'PATCH',
			requestPayload,
		);
	} catch (e) {
		yield put(errorHandlerActions.handleError(e, 'ignore'));
		yield put(notificationsActions.updateNotificationStatusError());
	}
}
